// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EX2cB","col":"styles_col__2uFoS"};